export const queueData = {
  "title": null,
  "category": null,
  "queueNumber": null,
  "createdByAdmin": null,
  "createdDate": null,
  "updatedDate": null,
}